import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useDispatch, useSelector } from "react-redux";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";

import { updateFormData } from "../../../Redux/store/onboardingFormSlice";

const BusinessInfo = ({ setCurrentStep }) => {
  const formData = useSelector((state) => state.form.formData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [citizenType, setcitizenType] = useState(1);
  const [citizenTypeText, setcitizenTypeText] = useState("Australian");
  const [businessName, setBusinessName] = useState("");
  const [abn, setAbn] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [accountTypeId, setAccountTypeId] = useState(null);
  const [nonResCountry, setNonResCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState("");
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState("");
  const [taxId, setTaxId] = useState("");
  const [activity, setActivity] = useState(null);
  const [activityText, setActivityText] = useState("");
  const [otherActivity, setOtherActivity] = useState("");
  const [source, setSource] = useState("");
  const [transactionLevel, setTransactionLevel] = useState("");
  const [ownership, setOwnership] = useState("");
  const [businessRegNumber, setBusinessRegNumber] = useState("");
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");

  const [isConfirmReset, setIsConfirmReset] = useState(false);

  const [preselectedCitizenType, setpreselectedCitizenType] = useState({
    value: 1,
    label: "Australian",
  });
  const citizenTypedata = [
    {
      value: 1,
      label: "Australian",
    },
    {
      value: 2,
      label: "Non - Australian",
    },
    {
      value: 3,
      label: "U.S",
    },
  ];
  const countryData = [
    {
      value: 1,
      label: "USA",
    },
  ];
  const businessNatureData = [
    {
      value: 1,
      label: "Accredited Investor",
    },
    {
      value: 2,
      label: "High Net-Worth Individual",
    },
    {
      value: 3,
      label: "Sophisticated Investor",
    },
    {
      value: 4,
      label: "Wholesale Investor",
    },
  ];
  const businessActivityData = [
    {
      value: 1,
      label: "Capital Markets",
    },
    {
      value: 2,
      label: "Commodities",
    },
    {
      value: 3,
      label: "Financial Market",
    },
    {
      value: 4,
      label: "Real Estate",
    },
    {
      value: 5,
      label: "Stock Market",
    },
    {
      value: 6,
      label: "Others",
    },
  ];
  const handleContinue = () => {
    handlesave();
    setCurrentStep(3);
  };
  const handleSelectCitizenType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setcitizenType(selectedOption.value);
    setcitizenTypeText(selectedOption.label);
  };
  const handleSelectBusinessNature = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setBusinessNature(selectedOption.value);
    setBusinessNatureText(selectedOption.label);
  };

  const handleSelectCountry = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setNonResCountry(selectedOption.value);
    setNonResCountryText(selectedOption.label);
  };
  const handleSelectActivity = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setActivity(selectedOption.value);
    setActivityText(selectedOption.label);
  };
  const handleReset = () => {
    setCurrentStep(1);
  };
  const handleBack = () => {
    setCurrentStep(1);
  };
  const handlesave = () => {
    dispatch(updateFormData({ field: "citizenType", value: citizenType }));
    dispatch(
      updateFormData({ field: "citizenTypeText", value: citizenTypeText })
    );

    dispatch(updateFormData({ field: "businessName", value: businessName }));
    dispatch(
      updateFormData({ field: "businessAddress", value: businessAddress })
    );

    if (citizenType == 1 && accountTypeId == 5) {
      dispatch(updateFormData({ field: "abn", value: abn }));
    }
    if (citizenType == 2) {
      dispatch(
        updateFormData({ field: "nonResCountry", value: nonResCountry })
      );
      dispatch(
        updateFormData({
          field: "nonResCountryText",
          value: nonResCountryText,
        })
      );
    }
    if (citizenType == 3) {
      dispatch(
        updateFormData({
          field: "socialSecurityNumber",
          value: socialSecurityNumber,
        })
      );
      dispatch(updateFormData({ field: "taxId", value: taxId }));
    }
    dispatch(
      updateFormData({ field: "businessNature", value: businessNature })
    );
    dispatch(
      updateFormData({
        field: "businessNatureText",
        value: businessNatureText,
      })
    );
    if (
      citizenType == 2 ||
      citizenType == 3 ||
      (citizenType == 1 && accountTypeId != 5)
    ) {
      dispatch(
        updateFormData({ field: "businessRegNum", value: businessRegNumber })
      );
    }
    dispatch(updateFormData({ field: "businessActivity", value: activity }));
    dispatch(
      updateFormData({ field: "businessActivityText", value: activityText })
    );

    dispatch(updateFormData({ field: "fundingSource", value: source }));
    dispatch(
      updateFormData({ field: "transactionLevel", value: transactionLevel })
    );
    dispatch(updateFormData({ field: "ownership", value: ownership }));
    if (activity == 6) {
      dispatch(
        updateFormData({ field: "otherActivity", value: otherActivity })
      );
    }
  };
  useEffect(() => {
    if (formData) {
      setAccountTypeId(formData.accountType);
    }
  }, [formData]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4 mb-4">
          <div className=" border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2">
              <img
                src="/buildings.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">Business Information</h1>
            </div>
            <li className="text-xs ml-2 font-medium text-[#FF5050]">
              If you need to adjust any information from the previous section,
              please click on the “Reset Application” button
            </li>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <Dropdown
                  label={
                    <>
                      Tax Resident Country
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={citizenTypedata}
                  onSelect={handleSelectCitizenType}
                  preselectedValue={preselectedCitizenType}
                />
              </div>
              {citizenType == 2 && (
                <>
                  <div className="mt-2">
                    <Dropdown
                      label={
                        <>
                          Country
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={countryData}
                      onSelect={handleSelectCountry}
                    />
                  </div>
                </>
              )}

              <div className="mt-2">
                <Dropdown
                  label={
                    <>
                      Business Nature
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={businessNatureData}
                  onSelect={handleSelectBusinessNature}
                />
              </div>
              {(citizenType == 2 ||
                citizenType == 3 ||
                (citizenType == 1 && accountTypeId != 5)) && (
                <>
                  <div className="mt-4">
                    <label
                      htmlFor="source"
                      className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Business Registration Number
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="businessRegNumber"
                      name="businessRegNumber"
                      type="text"
                      value={businessRegNumber}
                      placeholder="Enter Number"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setBusinessRegNumber(e.target.value)}
                    />
                  </div>
                </>
              )}
              {citizenType == 3 && (
                <div className="mt-4">
                  <label
                    htmlFor="source"
                    className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Social Security Number
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="socialSecurityNumber"
                    name="socialSecurityNumber"
                    type="text"
                    value={socialSecurityNumber}
                    placeholder="Enter Number"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setSocialSecurityNumber(e.target.value)}
                  />
                </div>
              )}

              {citizenType == 1 && accountTypeId == 5 && (
                <div className="mt-4">
                  <label
                    htmlFor="abn"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    ABN<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="abn"
                    name="abn"
                    type="text"
                    value={abn}
                    placeholder="Enter ABN"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setAbn(e.target.value)}
                  />
                </div>
              )}
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col px-4 md:pl-0 pr-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="">
                <label
                  htmlFor="businessName"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Business Name<span className="text-red-500">*</span>
                </label>
                <input
                  id="businessName"
                  name="businessName"
                  type="text"
                  value={businessName}
                  placeholder="Business Name"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setBusinessName(e.target.value)}
                />
              </div>
              <>
                <div className="mt-4">
                  <Dropdown
                    label={
                      <>
                        Describe the business activity
                        <span className="text-red-500"> *</span>
                      </>
                    }
                    options={businessActivityData}
                    onSelect={handleSelectActivity}
                  />
                  {activity == 6 && (
                    <div className="mt-4">
                      <label
                        htmlFor="others"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Please mention business activity
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="others"
                        name="others"
                        type="text"
                        value={otherActivity}
                        placeholder="Other activity"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setOtherActivity(e.target.value)}
                      />
                    </div>
                  )}
                  <div className="mt-4">
                    <label
                      htmlFor="source"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Source of the funds including its origin
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="source"
                      name="source"
                      type="text"
                      value={source}
                      placeholder="Enter Source"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setSource(e.target.value)}
                    />
                  </div>
                </div>
              </>
              {citizenType == 3 && (
                <div className="mt-4">
                  <label
                    htmlFor="source"
                    className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Tax ID
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="taxID"
                    name="taxID"
                    type="text"
                    value={taxId}
                    placeholder="Enter Number"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setTaxId(e.target.value)}
                  />
                </div>
              )}
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col px-4">
              <div className="">
                <div className="">
                  <label
                    htmlFor="address"
                    className="block text-sm text-labelColour"
                  >
                    Address of Principal Place of Business{" "}
                    <span className="text-red-500"> *</span>
                  </label>
                  <textarea
                    id="address"
                    rows="3"
                    value={businessAddress}
                    onChange={(e) => {
                      setBusinessAddress(e.target.value);
                    }}
                    className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    placeholder="Add address..."
                  />
                </div>
              </div>
              <div className="mt-6">
                <label
                  htmlFor="source"
                  className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Nature and level of the intended transaction behaviour
                  <span className="text-red-500">*</span>
                </label>
                <input
                  id="transactionLevel"
                  name="transactionLevel"
                  type="text"
                  value={transactionLevel}
                  placeholder="Enter transaction behaviour"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setTransactionLevel(e.target.value)}
                />
              </div>
              <div className="mt-4">
                <label
                  htmlFor="source"
                  className="block whitespace-normal break-words dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Beneficial ownership of the funds used by this account with
                  Caprock
                  <span className="text-red-500">*</span>
                </label>
                <input
                  id="ownership"
                  name="ownership"
                  type="text"
                  value={ownership}
                  placeholder="Enter Ownership"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setOwnership(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className=" mt-4 flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
          <ConfirmResetButton onConfirm={handleReset} onBack={handleBack} />
        </div>
        <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
          <div className="w-full md:w-auto flex justify-center md:justify-end">
            <button className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm">
              <span>Save as Draft</span>
            </button>
          </div>
          <ConfirmContinueButton
            onContinue={handleContinue}
            buttonText="Continue"
            confirmTitle="Save Section"
            confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
          />
        </div>
      </footer>
    </div>
  );
};

export default BusinessInfo;
